module.exports = __webpack_public_path__ + "static/media/Chauffer Service.dd52fc3f.png";